module.exports = __webpack_public_path__ + "img/scheme-list-item.458d265a.svg";